export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/submissions/document")
        .then(response => {
          context.commit("setDocuments", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  // upload(context, file) {
  //   const data = new FormData();
  //   data.append("file", file);
  //   const config = {
  //     headers: { "content-type": "multipart/form-data" }
  //   };
  //   return new Promise((resolve, reject) => {
  //     window.axios
  //       .post("/submissions/document", data, config)
  //       .then(resolve)
  //       .catch(reject);
  //   });
  // },

  upload(context, data) {
    const form = new FormData();
    form.append("file", data.file);
    form.append("answer", JSON.stringify(data.form));
    const config = {
      headers: { "content-type": "multipart/form-data" }
    };
    return new Promise((resolve, reject) => {
      window.axios
        .post("/submissions/document", form, config)
        .then(resolve)
        .catch(reject);
    });
  }
};
